import { Validators } from "@angular/forms";
import { MimeTypes } from "../../upload-file-dnd/model/mimeTypes";
import { TemplateRef } from "@angular/core";

export enum FormatType {
  text = "text",
  text_object = "text_object",
  text_plate_webform = "text_plate_webform",
  text_email_webform = "text_email_webform",
  text_mobile_webform = "text_mobile_webform",
  text_customer_reference_webform = "text_customer_reference_webform",
  select = "select",
  select_webform = "select_webform",
  date = "date",
  date_webform = "date_webform",
  textarea = "textarea",
  textarea_webform = "textarea_webform",
  file = "file",
  file_webform = 'file_webform',
  chip = "chip",
  number = "number",
  number_webform = "number_webform",
  radio = "radio",
  radio_privacy = "radio_privacy",
  string = "string",
  auto_select = 'select',
  AUTO_COMPLETE = "auto_complete",
  multi_select =  "multi_select",
  multi_select_webform =  "multi_select_webform",
  recaptcha="recaptcha",
  spacer = "spacer",
  title = "title",
  text_webform = "text_webform",
  text_webform_with_tooltip = "text_webform_with_tooltip",
}

export interface SelectValue {
  id;
  value: string | number;
}

export interface RadioText {
  yesText: string;
  noText: string;
  privacyText: string;
}
export interface SummaryModel {
  formatType: FormatType;
  label: string;
  techname: string;
  source?: any;
  value?;
  validators?: Validators;
  tooltip?: string;
  select?: Array<any>;
  multi_select?: Array<SelectValue>;
  radio?: RadioText;
  widthColumn?: number;
  mimeTypeAccepted?: Array<MimeTypes>;
  readOnly?: boolean;
  fileList?:Array<any>;
  child?: Array<any>;
  tooltipContent?: TemplateRef<any>;
}
